import { makeStyles, createTheme } from "@material-ui/core";

// Update log
// FB  6192   02/06/2023  DK  Style sheet for PP pages

const theme = createTheme({
  palette: {
    primary: {
      main: "#18a2b8",
    },
  },
});

const useStyles = makeStyles({
  appBar: {
    backgroundColor: "#18a2b8",
    display: "flex",
    flexDirection: "row",
  },
  appTitle: {
    flexGrow: 1,
    color: "white",
  },
  logo: {
    maxWidth: 400,
    maxHeight: 150,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 250,
      maxHeight: 70,
    }
  },
  buttonActive: {
    backgroundColor: "#13607C",
    color: "white",
    textTransform: "capitalize",
    borderRadius: "5px",
    pointerEvents: "none",
    width: "-webkit-fill-available",
  },
  buttonInactive: {
    backgroundColor: "white",
    color: "#13607C",
    textTransform: "capitalize",
    borderRadius: "10px",
    border: "1px solid #13607C",
    "&:hover": {
      backgroundColor: "#13607C",
      color: "white"
    },
  },
  navigationButton: {
    backgroundColor: "#13607C !important",
    color: "white !important",
    textTransform: "capitalize !important",
    borderRadius: "10px !important",
  },
  flexend_Grid: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexBasis: "unset",
  },
  flexstart_Grid: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexBasis: "unset",
  },
  flexcenter_Grid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexBasis: "unset",
  },
  disabledButton: {
    backgroundColor: "lightgray !important",
    textTransform: "capitalize !important",
    color: "grey !important",
    borderRadius: "10px !important",
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: "#13607C",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  },
  otp: {
    width: "2rem !important",
    height: "2rem",
    margin: "0 0.5rem",
    fontSize: "1rem",
    border: "2px solid gray",
    "&:focus": {
      border: "2px solid #18a2b8",
      outlineColor: "transparent",
    },
  },
  otpError: {
    border: "2px solid red",
  },
  radioGroup: {
    "&.MuiFormGroup-root": {
      flexDirection: "row",
    },
  },
  disabledTextfield: {
    "&.Mui-disabled": {
      color: "black",
    },
  },
  pb10: {
    paddingBottom: "10px",
  },
  d_flex: {
    alignContent: "left",
    justifyContent: "left",
    display: "flex",
    paddingLeft:window.innerWidth < 768 ? "16px" : "80px",
  },
  Avatar: {
    '&.MuiAvatar-colorDefault': {
      color: "#13607C",
      background: "none",
      border: "1px solid #13607C"
    },
  },
  LogoText: {
    color: "#083A4D",
    paddingLeft: "5px"
  },
  Footer: {
    backgroundColor: "#13607C",
    color: "white",
    height: window.innerWidth < 768 ? "auto" :"140px"
  },
  flex_center: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center"
  },
  p_10: {
    padding: 10
  },
  appt_tab: {
    border: "none !important",
    color: "#13607C",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    borderRadius: "20px",
    textTransform: "capitalize",
    fontSize: "14px",
    "&.MuiTab-root": {
      textTransform: "capitalize",      fontWeight: "bold",color:"#13607C",

    },
    "&.Mui-selected": {
      backgroundColor: "#13607C",
      border: "none",
      color: "white",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      borderRadius: "20px",
      textTransform: "capitalize",
      fontSize: "14px",
      fontWeight: "bold",

    },
    "&.MuiTabs-indicator": {
      backgroundColor: "none"
    }
  },
  textbutton: {
    color: "#083A4D !important",
    textTransform: "capitalize !important",
    fontWeight: "700 !important",
    fontSize: "16px !important"
  },
  TablePagination_text: {
    fontfamily: "Inter",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#083A4D",
  },
  Button_NoCapt: {
    backgroundColor: "#13607C !important",
    color: "white !important",
    textTransform: "none !important",
    paddingInline: "20px !important",
    borderRadius: "10px !important",
  },
  Card_Home_mobile: {
    borderRadius: "8px !important",
  },
  CardAction_Home_mobile: {
    padding: "0px 0px 15px 15px !important"
  }
});

export default useStyles;
